import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IOrderCancelReason } from "@app/common";

interface OrderCancelReasonDeleteModalProps extends ModalInstance<IOrderCancelReason>, Omit<DeleteModalProps<IOrderCancelReason>, 'children'> {
  onDelete: (product: Partial<IOrderCancelReason>) => void;
}

export const OrderCancelReasonDeleteModal = (props: OrderCancelReasonDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer une raison d'annulation.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}